export default __webpack_public_path__ + "static/epa-lead-safe-white-43238ce11308464a1095c910c7d0d3af.png";